<template>
  <v-container fluid>
    <v-card>
      <v-card-text>
        <v-data-table
          :loading="isLoading"
          :headers="headers"
          :items="OnTheWayList"
        >
          <template v-slot:item.payments="{ item }">
            <PaymentForm :Order="item"></PaymentForm>
          </template>
          <template v-slot:item.confirm="{ item }">
            <!-- <v-btn icon color="teal">
              <v-icon>fas fa-check-double</v-icon>
            </v-btn> -->
            <!-- <p>{{ item }}</p> -->
            <Confirm
              :key="item._id + 'confirm'"
              :ReqURL="OntheWayItems"
              :Order="item"
              :Updated="ConfirmedData"
            ></Confirm>
          </template>

          <template v-slot:item.Total.qty="{ item }">
            <ItemView
              :key="item._id"
              :ReqURL="OntheWayItems"
              :query="{ OrderCode: item._id }"
              :price="item.Total.price"
              :CashType="item.CashType"
              :Updated="OnTheWayLoad"
            >
              <strong>{{
                Math.abs(parseInt(item.Total.qty)).toLocaleString()
              }}</strong>
            </ItemView>

            <!-- <ItemView>heelow</ItemView> -->
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <OnTheWay :OnFinish="OnTheWayLoad"></OnTheWay>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
export default {
  components: {
    // OnTheWay: () => import("@/components/HQ/TheWay/items/BulkInventory"),
    OnTheWay: () => import("@/components/HQ/TheWay/items/Add_On_The_Way.vue"),
    ItemView: () => import("@/components/HQ/TheWay/items/ViewItems.vue"),
    PaymentForm: () => import("@/components/HQ/TheWay/Costs/_WayOptions.vue"),
    Confirm: () => import("@/components/HQ/TheWay/items/confirm.vue"),
  },
  data() {
    return {
      Stock: "/stock/Ontheway",
      OntheWayItems: "/stock/Ontheway/items",
      isLoading: false,
      OnTheWayList: [],
      headers: [
        {
          text: "Date",
          align: "left",
          value: "Date",
          class: "teal darken-3 white--text",
        },
        { text: "Code", value: "_id", class: "teal darken-3 white--text" },
        {
          text: "Supplier",
          value: "SuppName",
          class: "teal darken-3 white--text",
        },
        {
          text: "Exp-QTY",
          value: "Total.qty",
          class: "teal darken-3 white--text",
        },
        {
          text: "Payments",
          value: "payments",
          class: "teal darken-3 white--text",
        },
        {
          text: "Confirm",
          value: "confirm",
          class: "teal darken-3 white--text",
        },
      ],
    };
  },
  methods: {
    getReByQuery(value) {
      return this.$store.dispatch("FIND_BY_VALUE", value);
    },
    getReq(url) {
      return this.$store.dispatch("GET_ONLY", url);
    },

    OnTheWayLoad(data = []) {
      if (data && data.length) {
        this.OnTheWayList = data;
        return;
      }
      this.isLoading = true;
      this.getReByQuery({ url: this.Stock })
        .then(val => {
          // console.log(val.data[0].Items);
          this.OnTheWayList = val.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    ConfirmedData(order) {
      this.OnTheWayList = this.OnTheWayList.filter(
        item => order._id != item._id
      );
    },
  },
  created() {
    this.OnTheWayLoad();
  },
};
</script>
